import { C, P0, R, S, abs, frac, hexCore, lerp, moodK } from '../../geometry';

export const spark = {
  name: 'Spark',
  colors: ['#E3A008', '#E5484D'],
  draw(m, t) {
    let rot = 8 * S(t * 0.6),
      r0 = 27,
      r1 = 37,
      pulse = 0,
      pose = P0(),
      long = -1;
    if (m === 'happy') {
      rot = 16 * S(t * 4);
      r1 = 41 + 4 * S(t * 8);
      pose.ty = -2 * abs(S(t * 6));
    }
    if (m === 'thinking') {
      rot = 22 * S(t * 0.9);
      r1 = 33;
      long = Math.floor(frac(t * 0.8) * 6);
    }
    if (m === 'talking') pulse = 1;
    if (m === 'surprised') {
      r0 = 25;
      r1 = 45;
      rot = 2 * S(t * 25);
    }
    if (m === 'paused') {
      r0 = 31;
      r1 = 32.5;
      rot = 3 * S(t * 0.5);
      pose.ty = 2;
    }
    const strokes = [0, 1, 2, 3, 4, 5].map((i) => {
      const a = (i * 60 - 90 + rot) * R;
      const e = pulse
        ? r1 + 6 * S(t * 10 - i * 1.05)
        : i === long
          ? r1 + 9
          : r1;
      return {
        c: i % 2 ? 'b' : 'a',
        pts: [0, 1, 2].map((k) => {
          const r = lerp(r0, e, k / 2);
          return [50 + r * C(a), 52 + r * S(a)];
        }),
      };
    });
    return { strokes, eyes: { x: 50, y: 52 }, pose };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    const rot = m === 'thinking' ? t * 70 : 6 * S(t * 0.6);
    f.strokes.unshift({
      c: 'a',
      fill: true,
      pts: hexCore(17 * moodK(m, t), rot),
      n: 30,
    });
    return f;
  },
};
